module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/title-top_06917cd0c06153ab81d72dee270eb3ed.png";